import React from 'react';

import { AssetDetailsPage as AssetDetailsPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';
import { useAdStudioInlineChart } from '../performance-page/hooks/use-inline-chart';

const globalLegacyI18n = window && window.globalLegacyI18n;

export const AssetDetailsPage = (props) => {
  const { getGranularityEnum } = useAdStudioInlineChart({
    serverContext: props.serverContext,
    globalLegacyI18n,
    // forceToResizeChart,
  });

  return (
    <AssetDetailsPageComponent {...props} notificationApi={notificationApi} getGranularityEnum={getGranularityEnum} />
  );
};
